import {
  Component,
  Input,
  OnInit,
  ViewChild
} from "@angular/core";
import { BsModalService } from "ngx-bootstrap/modal";
import { firstValueFrom } from "rxjs";
import { FesRutTestPointConfig, FesRutTestPointTestParams, VolunteerTaskPointViewRecord } from "../../models";
import { InlineEdit, VolunteerTaskPointTestParamsComponent } from "../volunteer-task-point-test-params/volunteer-task-point-test-params.component";

export type TestParamsModalEditResult = {
  testParameters?: FesRutTestPointTestParams;
  changes: InlineEdit<any>[];
};

@Component({
  selector: "app-volunteer-task-point-test-params-modal",
  templateUrl: "volunteer-task-point-test-params-modal.component.html",
})
export class VolunteerTaskPointTestParamsModalComponent implements OnInit {

  static async selectTestParams(
    modalService: BsModalService,
    config: FesRutTestPointConfig,
    taskPoint?: VolunteerTaskPointViewRecord,
  ) {
    const results: TestParamsModalEditResult&{cancelled?:boolean} = {changes:[]};
    const modalId = 'VolunteerTaskPointTestParamsModalComponent'+Date.now();
    const modal = modalService.show(VolunteerTaskPointTestParamsModalComponent, {
      ignoreBackdropClick: true,
      initialState: { 
        config,
        taskPoint,
        onSave: async ( testPararmeters: FesRutTestPointTestParams, changes: InlineEdit<any>[] ) => {
          results.testParameters = testPararmeters;
          results.changes = changes;
        },
        modalService,
        modalId
      },
      id: modalId,
      //class: modalClass,
    });
    await firstValueFrom(modal.onHidden);
    return {...results, cancelled: modal.content.cancelled};
  }

  @Input() config: FesRutTestPointConfig;

  @Input() taskPoint: VolunteerTaskPointViewRecord;

  @Input() onSave: (testParameters: FesRutTestPointTestParams, changes: InlineEdit<any>[]) => Promise<void>;
  
  @Input() modalService!: BsModalService;

  @Input() modalId!: string;

  @ViewChild('paramsComponent') paramsComponent: VolunteerTaskPointTestParamsComponent;

  bSaving = false;
  errorMsg = "";
  cancelled = false;

  constructor() {
  }

  ngOnInit(): void {
  }


  save = async () => {
    try {
      const testParameters = this.paramsComponent.getFormData();
      const changes = this.paramsComponent.getChanges();
      this.bSaving = true;
      this.cancelled = false;
      await this.onSave(testParameters,changes);
      this.modalService.hide(this.modalId);
    } catch ( e: any ) {
      this.errorMsg = e.message;
    } finally {
      this.bSaving = false;
    }
  }

  cancel = () => {
    this.cancelled = true;
    this.paramsComponent?.resetInlineEdits();
    this.modalService.hide(this.modalId);
  }

}
